import ShopItemsView from "../../components/shopItemsView/shopItemsView";

const GemsandMiningItemsOwnerView = () => {
    return (
        <div>
            <ShopItemsView update="/minerals-mining-item-update" deleteurl="/minerals-and-mining-profile" urlone="/minerals-and-mining-profile"/>
        </div>
    )
}
export default GemsandMiningItemsOwnerView;